import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import Input from '../../../../../components/input';

class VCode extends React.PureComponent {
    static propTypes = {
        getCode: PropTypes.func,
        isAble: PropTypes.bool,
    };

    state = {
        txt: '获取验证码',
        timeCount: 59,
        btnDisable: false,
        isAble: this.props.isAble,
        hasSend: false,
    };

    static getDerivedStateFromProps = (props, state) => {
        let resIsAble = {};

        if (props.isAble !== state.isAble) {
            resIsAble = { isAble: props.isAble };
        }

        return { ...resIsAble };
    };

    startCountDown = () => {
        let timeCount = this.state.timeCount;

        // console.log(timeCount);
        this.setState({
            txt: `${60}秒后重新获取`,
            btnDisable: true,
            hasSend: true,
        });
        const timer = setInterval(() => {
            this.setState(
                {
                    txt: `${timeCount}秒后重新获取`,
                    timeCount: timeCount--,
                },
                () => {
                    if (timeCount < 0) {
                        clearInterval(timer);
                        this.setState({
                            txt: '获取验证码',
                            timeCount: 60,
                            btnDisable: false,
                            hasSend: false,
                        });
                    }
                },
            );
        }, 1000);
    };

    // 点击获取验证码
    getCode = () => {
        const { btnDisable } = this.state;

        if (btnDisable) {
            return;
        }

        this.props.getCode(this.startCountDown);
    };

    render() {
        const { txt, btnDisable, hasSend } = this.state;

        return (
            <div className={styles.vCode}>
                <div className={`${styles.getMsgPinBtn} ${btnDisable ? styles.disable : ''}`} onClick={this.getCode}>
                    {txt}
                </div>
                {hasSend ? (
                    <span className={styles.tip}>验证码已发送，24小时之内请勿频繁获取验证码</span>
                ) : (
                    <span className={styles.tip}>24小时之内请勿频繁获取验证码</span>
                )}
            </div>
        );
    }
}

export default errorBoundary(VCode);
